module.exports = __webpack_public_path__ + "img/point2_bg.28ffc914.jpg";